import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { UserSalary } from './types';
import { getUserSalariesByLocalId } from '../../../../crud/management_api/user_salaries';
import EstadisticasSalary from './Estadisticas/EstadisticasSalary';
import Table from './components/Listado/Table/Table';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { BsFillCaretRightFill } from 'react-icons/bs';
import { FaChartPie } from 'react-icons/fa';
import TableSearchBar from '../../../../components/common/Table/TableSearchBar';

const Salario: React.FC = () => {
  const [showListado, setShowListado] = useState(true);
  const [showEstadisticas, setShowEstadisticas] = useState(false);
  const [userSalaries, setUserSalaries] = useState<UserSalary[]>([]);
  const [loading, setLoading] = useState(false);
  const [filteredSalaries, setFilteredSalaries] = useState<UserSalary[]>([]);

  useEffect(() => {
    const fetchUserSalaries = async () => {
      setLoading(true);
      try {
        const user = JSON.parse(localStorage.getItem('user') ?? '{}');
        const localId = user?.local_id || 0;

        if (localId) {
          const response = await getUserSalariesByLocalId(localId);
          if (response && Array.isArray(response.data)) {
            setUserSalaries(response.data);
            setFilteredSalaries(response.data);
          } else {
            console.error('Error: Respuesta de API no válida');
          }
        } else {
          console.warn('Local ID no encontrado en localStorage');
        }
      } catch (error) {
        console.error('Error al obtener los salarios:', error);
      } finally {
        setLoading(false);
      }
    };

    if (showListado) {
      fetchUserSalaries();
    }
  }, [showListado]);

  const handleShowListado = () => {
    setShowListado(true);
    setShowEstadisticas(false);
  };

  const handleShowEstadisticas = () => {
    setShowEstadisticas(true);
    setShowListado(false);
  };

  // renderHeader con título principal y subtítulo dinámico
  const renderHeader = () => {
    const dynamicTitle = showListado
      ? 'Salarios'
      : 'Salarios-Estadísticas';
    const [mainTitle, subTitle] = dynamicTitle.split('-');

    return (
      <div className="mp-page-header-container">
        <h2 className="title">{mainTitle}
        {subTitle && <h4 className="subtitle">{subTitle}</h4>}
        </h2>
        <div className="buttons">
          {!showListado && (
            <Button onClick={handleShowListado}>
              Listado <BsFillCaretRightFill/>
            </Button>
          )}
          {!showEstadisticas && (
            <Button onClick={handleShowEstadisticas}>
              Estadísticas <FaChartPie/>
            </Button>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      <div className="mp-page-content">
        {loading ? (
          <LoadingSpinner text="Cargando salarios..." transparent={true}/>
        ) : showListado ? (
          <>
            {/* ——— Buscador ——— */}
            <TableSearchBar
              data={userSalaries}
              updateFilteredData={setFilteredSalaries}
              searchFields={['username', 'last_name']}
              placeholder="Buscar salarios..."
            />
            {/* ——— Tabla con el array ya filtrado ——— */}
            <Table data={filteredSalaries} setData={setUserSalaries}/>
          </>
        ) : (
          <EstadisticasSalary salaryList={userSalaries}/>
        )}
      </div>
    </>
  );
};

export default Salario;
